import React from "react"
import styled from 'styled-components';
import RowItem from "./RowItem"
import NextArrow from "./NextArrow"
import {Link} from "react-router-dom"

const Li = styled.li`
color: white;
height: auto;
padding-bottom: 2rem;
list-style: none;
`

const H3 = styled(Link)`
    font-size: 1.5rem;
    margin-bottom: 1rem;
    font-weight: 700;
    color: white;
    text-decoration: none;
    display: inline-block;
    border-left: 4px solid #00d2ff;
    padding-left: 15px;
    transition: all 0.3s ease;

    &:hover { color: #00d2ff; }
`

const GroupRow = ({category_id, name, style, playlist, isSeries}) => {
    const playingMode = isSeries ? "series" : "movie";
    
    return (
        playlist.length > 0 && (
        <Li style={style}>
            <H3 to={`/${playingMode}/category/${category_id}/`}>{name}</H3>
            <div style={{display: 'flex', overflowX: 'auto', padding: '10px 0', scrollbarWidth: 'none'}}>
                {playlist.map((item)=>
                    (<RowItem 
                        key={item.stream_id || item.series_id} 
                        name={item.name} 
                        stream_icon={item.stream_icon || item.cover} 
                        stream_id={item.stream_id || item.series_id} 
                        playingMode={playingMode}
                    />)
                )}
            </div>
        </Li>
        )
    )
}

export default GroupRow
